import { IDocumentControlContentLanguageLabelModel } from '@fi-app/document/document';

export class DocumentControlContentLanguageLabelModel implements IDocumentControlContentLanguageLabelModel {
    Id: number;
    DocumentContentId: number;
    PlaceHolderControlId: number;
    ContentLanguageId: number;
    ControlType: any;
    Value;

    constructor(data?: IDocumentControlContentLanguageLabelModel) {
        data = data || ({} as IDocumentControlContentLanguageLabelModel);

        this.Id = data.Id || 0;
        this.DocumentContentId = data.DocumentContentId || 0;
        this.PlaceHolderControlId = data.PlaceHolderControlId || 0;
        this.ContentLanguageId = data.ContentLanguageId || 0;
        //this.ContentLanguageLabelObjectType = data.ContentLanguageLabelObjectType || 0;
        try {
            this.Value = typeof data.Value == 'string' ? JSON.parse(data.Value) : data.Value || {};
        } catch (e) {
            console.error('FI: Error in document content.', '\r\nValue: ', data.Value, '\r\nError: ', e);
            this.Value = {};
        }

        this.ControlType = data.ControlType;
    }
}
